import styled from 'styled-components';

export const AccordionSectionWrapper = styled.div`
  width: 100%; max-width: none; margin: 0;
  .accordion__item { border-bottom: 1px solid #e1e7f0; }
  .accordion__heading { margin: 0; }
  .accordion__button { display: flex; justify-content: space-between; gap: 24px; align-items: center; padding: 24px 0; cursor: pointer; color: #1b264f; font: 600 20px/1.5 Poppins, sans-serif; text-transform: none; }
  .accordion__item:first-child .accordion__button { padding-top: 0; }
  .accordion__button::after { content: '+'; color: #2c5bff; font: 400 28px/1 sans-serif; flex-shrink: 0; }
  .accordion__button[aria-expanded='true']::after { content: '−'; }
  .accordion__button:focus-visible { outline: 3px solid #7c9aff; outline-offset: 5px; border-radius: 4px; }
  .accordion__panel { padding: 0 32px 24px 0; color: #52617e; font: 400 18px/1.75 'Nunito Sans', sans-serif; overflow-wrap: anywhere; }
  .accordion__panel p { margin: 0 0 16px; }
  .accordion__panel p:last-child { margin-bottom: 0; }
  .accordion__panel ul, .accordion__panel ol { padding-left: 24px; }
  .accordion__panel li { margin-bottom: 8px; }
  .accordion__panel a { color: #2c5bff; text-decoration: underline; text-underline-offset: 3px; }
  .accordion__panel img { max-width: 100%; height: auto; }
  .accordion__panel h2, .accordion__panel h3 { color: #1b264f; text-transform: none; font: 600 20px/1.5 Poppins, sans-serif; margin: 16px 0 12px; }
  @media (max-width: 767px) { .accordion__button { font-size: 18px; gap: 16px; padding: 22px 0; } .accordion__panel { font-size: 17px; padding-right: 0; padding-bottom: 22px; } }
`;
